import { translate } from "app/filters/i18nFilter";
import { EIndustryAssess, ETotalScore } from "../common/types";
import { colorsPalettes } from "@similarweb/styles";
import { NOT_AVAILABLE } from "app/filters/const";

const { red, green, orange, carbon } = colorsPalettes;

const difficultyStatusColorObj = {
    [ETotalScore.HEIGH]: red.s100,
    [ETotalScore.Medium]: orange[400],
    [ETotalScore.LOW]: green.s100,
    [ETotalScore.NO_DATA]: carbon[250],
};

const difficultyStatusNameObj = {
    [ETotalScore.HEIGH]: "industryoverview.market.difficulty.status.high",
    [ETotalScore.Medium]: "industryoverview.market.difficulty.status.medium",
    [ETotalScore.LOW]: "industryoverview.market.difficulty.status.low",
    [ETotalScore.NO_DATA]: NOT_AVAILABLE,
};

const industryAssessKeyColorObj = {
    [EIndustryAssess.ABOVE_AVERAGE]: red.s100,
    [EIndustryAssess.ON_AVERAGE]: orange[400],
    [EIndustryAssess.BELOW_AVERAGE]: green.s100,
};

const industryAssessKeyNameObj = {
    [EIndustryAssess.ABOVE_AVERAGE]: "industryoverview.market.difficulty.cube.above.average",
    [EIndustryAssess.ON_AVERAGE]: "industryoverview.market.difficulty.cube.on.average",
    [EIndustryAssess.BELOW_AVERAGE]: "industryoverview.market.difficulty.cube.below.average",
};

export const getDifficultyStatusColor = (industryAssess: ETotalScore): string => {
    return difficultyStatusColorObj[industryAssess];
};

export const getDifficultyStatusName = (industryAssess: ETotalScore): string => {
    return translate(difficultyStatusNameObj[industryAssess]);
};

export const getAssessColor = (industryAssess: EIndustryAssess): string => {
    return industryAssessKeyColorObj[industryAssess];
};

export const getAssessName = (industryAssess: EIndustryAssess): string => {
    return translate(industryAssessKeyNameObj[industryAssess]);
};
